import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BodyCopy, Headline } from '@xingternal/typography';
import styles from './EmptyState.css';
import Image from '@/assets/images/managedEmptyState.png';
import { trackingParams } from '@/utils/tracking';
import { EXTERNAL_LINKS } from '@/routes';
import BaseButton from '@/components/BaseButton';

const EmptyState: React.FC = () => {
  return (
    <div className={styles.emptyStateCard}>
      <div className={styles.textLayer}>
        <Headline size="xxlarge" className={styles.text}>
          <FormattedMessage id="CP_EMPTY_STATE_MANAGED_HEADER" />
        </Headline>
        <BodyCopy className={styles.text}>
          <FormattedMessage id="CP_EMPTY_STATE_MANAGED_SUBHEADER" />
        </BodyCopy>
        <div>
          <BaseButton
            href={EXTERNAL_LINKS.newCompany}
            trackingAttributes={trackingParams.createProfile}
            size="small"
            variant="secondary"
            className={styles.button}
          >
            <FormattedMessage id="CP_EMPTY_STATE_MANAGED_BUTTON" />
          </BaseButton>
        </div>
      </div>
      <img src={Image} className={styles.image} />
    </div>
  );
};

export { EmptyState };
